import { createFileRoute } from "@tanstack/react-router";
import { OnboardingRecordsPage } from "@/features/dashboard/pages/onboarding-records";

export const Route = createFileRoute("/(app)/dashboard/onboarding-records")({
  component: () => <OnboardingRecordsPage />,
});
